import { displayFnWrapperArrayFlatter } from './common-display-fn';

export const emeaMinDivisibleSpaceAvailableFunctions = {
  423: {
    // 423 - Min Divisible Space Available (Poland & Finland)
    displayFn: displayFnWrapperArrayFlatter,
  },
  433: {
    // 433 - Min Divisible Space Available (Italy)
    displayFn: displayFnWrapperArrayFlatter,
  },
  510: {
    // 510 - Min Divisible Space Available (Norway)
    displayFn: displayFnWrapperArrayFlatter,
  },
  520: {
    // 520 - Min Divisible Space Available (Norway)
    displayFn: displayFnWrapperArrayFlatter,
  },
  500: {
    // 500 - Min Divisible Space Available (Sweden)
    displayFn: displayFnWrapperArrayFlatter,
  },
};
